import React from 'react'
import { BiX } from "react-icons/bi";
import BaseInput from '../General/FormsComp/Input/BaseInput';
import BaseButton from '../General/FormsComp/Button/BaseButton';

const Editar = ({ servico, setServico, closeModal, handleSubmit }) => {

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setServico({ ...servico, [name]: value });
    };

    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4' onClick={(e) => e.target === e.currentTarget && closeModal()}>
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-md w-full mx-4 overflow-hidden flex flex-col'>
                {/* Header */}
                <div className='flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700'>
                    <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
                        Editar Serviço
                    </h1>
                    <button 
                        onClick={() => closeModal()} 
                        className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700'
                    >
                        <BiX className='w-6 h-6' />
                    </button>
                </div>

                {/* Content */}
                <div className='flex-1 p-6'>
                    <div className='space-y-4'>
                        <BaseInput
                            label="Nome do Serviço"
                            name="nome"
                            value={servico.nome || ''}
                            onChange={handleInputChange}
                            placeholder="Digite o nome do serviço"
                            required
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
                    <BaseButton
                        onClick={closeModal}
                        variant="ghost"
                        size="md"
                    >
                        Cancelar
                    </BaseButton>
                    <BaseButton
                        onClick={handleSubmit}
                        variant="primary"
                        size="md"
                    >
                        Salvar
                    </BaseButton>
                </div>
            </div>
        </div>
    )
}

export default Editar
